<template>
  <div class="power-box-wrap">
    <div class="power-box">
      <div class="bg-img"></div>
      <div class="texts" v-if="this.$route.query.msg">抱歉，{{ this.$route.query.msg }}</div>
      <div class="texts" v-else :style="{ paddingBottom: enterprise.default.ID && adminList.length ? '80px' : '20px' }">抱歉，你暂无相关权限</div>
      <div class="hints" v-if="enterprise.default.ID">请联系本公司管理员分配权限:</div>
      <div class="cent">
        <div class="items" v-for="(item, index) in adminList" :key="index">
          <div class="img"></div>
          <div class="name">{{ item.Name }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import "./power.scss";
</style>

<script>
import { mapState } from "vuex";

export default {
  computed: {
    ...mapState({
      enterprise: (state) => state["shop/shop"].enterprise,
    }),
  },
  data() {
    return {
      adminList: [],
    };
  },
  created() {
    this.$store.commit("app/setShowTitle", false);
    const { ID } = this.enterprise.default;
    this.$store
      .dispatch("app/getadminList", {
        enterpriseid: ID,
      })
      .then((data = []) => {
        this.adminList = data;
      });
  },
};
</script>
